import {createSelector} from 'reselect';

const selectTable = state => state.get('tableReducer');

const makeSelectIsRequestPending = () => createSelector(
  selectTable,
  table => table.isRequestPending
);

const makeSelectResponses = () => createSelector(
  selectTable,
  table => table.responses
);

const makeSelectError = () => createSelector(
  selectTable,
  table => table.error
);

export {
  makeSelectIsRequestPending,
  makeSelectResponses,
    makeSelectError
};
